import Comp from './SignUpForm'
export default Comp
